import { computed, ComputedRef } from 'vue'
import { DateTime } from 'luxon'
import { getEasterSunday } from '@/composables/themes/holidayHelper'

export type UseEaster = {
  /** Easter Sunday for the current year */
  easter: DateTime
  /** True if today is Easter Sunday */
  isEasterToday: ComputedRef<boolean>
  /**
   * True if today is between 4 weeks before Easter
   * and 1 week after Easter
   */
  isWithinEasterRange: ComputedRef<boolean>
}

function useEaster(): UseEaster {
  const today = DateTime.local().startOf('day')
  const easter = getEasterSunday(today.year)

  const isEasterToday = computed(() => today.hasSame(easter, 'day'))

  const easterStart = easter.minus({ weeks: 4 })
  const easterEnd = easter.plus({ weeks: 1 })
  const isWithinEasterRange = computed(() => today >= easterStart && today <= easterEnd)

  return {
    easter,
    isEasterToday,
    isWithinEasterRange,
  }
}

export default useEaster
